import { createDataFunction } from '../../functions/index.js';
import { models } from '../../index.js';
export const createMe = createDataFunction({
    id: '860628',
    name: 'Nisse',
    email: 'nisse@email.se',
    role: models.UserRole.CESG,
    status: models.UserStatus.ACTIVE,
    permissions: [],
});
